export const serialize = (data) => (
  {
    id: parseInt(data.id),
    message: data.message,
    read: parseInt(data.readed, 10) === 1,
  }
);


